
import React from "react";
import OrderStatusComponent from "../../components/checkout/orderStatusComponent";

export default function OrderStatusPage() {
    return <OrderStatusComponent />;
}